import NotificationImage from 'assets/images/no-notifications.png';
import { useTranslation } from 'react-i18next';

export default function NoNotification() {
  const { t } = useTranslation();

  return (
    <div className='w-full h-[calc(100vh-18rem)] lg:h-[calc(100vh-14rem)] flex flex-col items-center justify-center gap-6'>
      <img
        src={NotificationImage}
        alt='no-notification'
        className='object-contain size-36 md:size-44 lg:size-60'
      />
      <div className='text-center'>
        <h2 className='text-base font-semibold md:text-lg'>
          {t('no_notification_title')}
        </h2>
        <p className='text-sm md:text-base'>{t('no_notification_desc')}</p>
      </div>
    </div>
  );
}
